import * as _ from 'lodash-es';

const isThrottlingError = (response: any) => {
    if (!response.headers || !response.headers()) {
        //For syntax errors in JSON response, we don't get response.config object
        return false;
    }
    var errorTypeHeaderVal = response.headers()['x-amzn-errortype'];
    return errorTypeHeaderVal && _.startsWith(errorTypeHeaderVal, "ThrottlingException:") && response.status === 400;
};

const isRetriableError = (response: any) => {
    if (isThrottlingError(response)) {
        return true;
    }
    
    if (response.status === -1) {        
        if (typeof response.config.timeout === 'number' || 
            (typeof response.config.timeout === 'object' && response.config.timeout.$$state.status)) {
            //If the status is -1, only return true if it is not a timeout scenario
            return false;
        }
        return true;
    }

    //-1 status code is returned when a network request is cancelled by the browser due to network glitch (the && check will make sure there is no timeout that caused it)
    //Other status codes are common retriable errors.
    return response.status === 502 || response.status === 503 || response.status === 504;
};

export {isThrottlingError, isRetriableError};